module.exports = __webpack_public_path__ + "media/assets/icons/checkmark-colorless-fc88a4f0e0bafa7c60ec64cc52aa4bfa.svg";